const cardPaymentMethods = ['generic_credit_card', 'safe_credit_card', 'redsys_caixabank', 'redsys_deutsche_bank', 'amex', 'goforajourney_credit_card']

export {cardPaymentMethods}
